import moment from "moment";

export const parseSSEStream = async (readableStream, onEvent) => {
  const reader = readableStream.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      const parts = buffer.split("\n\n");
      buffer = parts.pop() ?? "";

      for (const part of parts) {
        if (!part.trim()) continue;
        const lines = part.split("\n");
        let eventType = "message";
        let eventData = "";

        for (const line of lines) {
          if (line.startsWith("event: ")) {
            eventType = line.slice(7).trim();
          } else if (line.startsWith("data: ")) {
            eventData = line.slice(6);
          }
        }

        if (eventData) {
          try {
            const result = onEvent({ type: eventType, data: JSON.parse(eventData) });
            if (result instanceof Promise) await result;
          } catch {
            // ignore malformed events
          }
        }
      }
    }
  } finally {
    reader.releaseLock();
  }
};

export const buildConversationHistory = (messages, newUserMessage) => {
  const history = (messages || []).map((msg) => ({
    role: msg.isUser ? "user" : "assistant",
    content: msg.text?.response || "",
  }));
  history.push({ role: "user", content: newUserMessage });
  return history;
};

export const formatTimestamp = (date) => {
  const parsedDate = new Date(date);

  if (Number.isNaN(parsedDate.getTime())) {
    return "";
  }

  return parsedDate.toISOString().replace("T", " ").slice(0, 19);
};


export const extractBlobErrorMessage = async (error, fallback) => {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed.detail || parsed.message || fallback;
    } catch {
      return fallback;
    }
  }
  return error?.response?.data?.detail || error?.response?.data?.message || error?.message || fallback;
};

export const handleShare = async (doc, handleError) => {
    // setAnchorEl(null);
    if (navigator.share) {
      try {
        await navigator.share({
          title: doc.title,
          text: `Document: ${doc.fileName || doc.title}\nDate: ${moment(doc.timestamp || doc.createdAt).format("ll")}\nURL:${doc?.fileUrl || ""}`,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      handleError("Share is not supported in your browser.");      
    }
  };
